import { UseCaseSelection } from '../enums/use-case-selection.enums.js'
import { WorkInstructionFlag } from '../enums/work-instruction.enums.js'

// 条件
const state = {
  useCaseSelections: []
}

// アクション
const actions = {
  async updateUseCaseSelections({ commit }, value) {
    commit('setUseCaseSelections', value)
  }
}

// 突然変異
const mutations = {
  setUseCaseSelections(state, value) {
    state.useCaseSelections = value
  }
}

// ゲッターズ
const getters = {
  /**
   * ログインしたユーザーに「NO_TASK_SORT」のユースケースがあるかどうかを確認します。
   *
   * @returns {boolean} ログインしたユーザーが「NO_TASK_SORT」use-caseを持っている場合、trueを返します、それ以外の場合はfalse
   */
  hasNoTaskSortUseCase() {
    return hasUseCase(UseCaseSelection.NO_TASK_SORT)
  },

  /**
   * ログインしたユーザーに「ORDER_SORT」のユースケースがあるかどうかを確認します。
   *
   * @return {boolean} ログインしたユーザーが「ORDER_SORT」use-caseを持っている場合、trueを返します、それ以外の場合はfalse
   */
  hasOrderSortUseCase() {
    return hasUseCase(UseCaseSelection.ORDER_SORT)
  },

  /**
   * ユーザーが「NO_TASK_SORT」usecaseのみを持っているかどうかを確認してください。
   *
   * @returns {boolean} ユーザーが「NO_TASK_SORT」use-caseのみを持っている場合、trueを返し、それ以外の場合はfalse
   */
  isOnlyNoTaskSortUseCase() {
    return state.useCaseSelections.every(useCase => useCase === UseCaseSelection.NO_TASK_SORT)
  },

  /**
   * チェック・ユースケースの選択は作業指示による。
   *
   * @param {number} workInstruction 作業指示
   * @returns {boolean} ユースケースが作業指示と一致する場合はtrueを、一致しない場合はfalseを返します
   */
  hasUseCaseOnWorkInstruction: () => (workInstruction) => {
    if (isAllUseCase()) {
      return true
    }
    const useCaseSelections = state.useCaseSelections
    switch (workInstruction) {
      case WorkInstructionFlag.NO_WORK_INSTRUCTION:
        return useCaseSelections.includes(UseCaseSelection.NO_TASK_SORT)
      case WorkInstructionFlag.WORK_INSTRUCTION:
        return useCaseSelections.includes(UseCaseSelection.ORDER_SORT)
      default:
        return false
    }
  }
}

/**
 * ユースケースの選択を確認してください。
 *
 * @param {number} useCase ユースケース
 * @returns {boolean} ユースケースが選択されている場合はtrueを、選択されていない場合はfalseを返します
 */
function hasUseCase(useCase) {
  const useCaseSelections = state.useCaseSelections
  return useCaseSelections.includes(UseCaseSelection.ALL) || useCaseSelections.includes(useCase)
}

/**
 * ユースケースの選択がフルモードかどうかをチェックする。
 *
 * @returns {boolean} フルモードのユースケース選択であればtrueを、そうでなければfalseを返す
 */
function isAllUseCase() {
  const useCaseSelections = state.useCaseSelections
  return (
    useCaseSelections.includes(UseCaseSelection.ALL) ||
    (useCaseSelections.includes(UseCaseSelection.ORDER_SORT) && useCaseSelections.includes(UseCaseSelection.NO_TASK_SORT))
  )
}

export const useCaseSelection = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/_store/use-case-selection.module.js